import { Box, Flex, Heading, SimpleGrid, useBreakpointValue } from "@chakra-ui/react";
import {
  DelayedFlight,
  TechnicalSupport,
  Cookies,
  Compensation,
  VegetarianFood,
  Meeting,
  LocalMall,
} from "@airhelp/icons";
import type { As } from "@chakra-ui/react";
import { Grid } from "modules/common/components/Grid";
import RichtextAdapter from "modules/storyblok/adapters/RichtextAdapter";
import type { HowScoreIsCalculatedItems, HowScoreIsCalculatedProps } from "./HowScoreIsCalculated.d";
import { headingStyles, itemTextStyles } from "./HowScoreIsCalculated.styles";

const icons = {
  DelayedFlight,
  TechnicalSupport,
  Cookies,
  Compensation,
  VegetarianFood,
  Meeting,
  LocalMall,
};

const HowScoreIsCalculated = ({ items, heading }: HowScoreIsCalculatedProps) => {
  const headingSize = useBreakpointValue({ base: "h3", lg: "h4" });

  return (
    <Grid mb={0} py={{ base: 12, lg: 24 }}>
      <Box gridColumn={{ base: "span 1", md: "span 12" }} flexDir="column">
        <Flex
          justifyContent="space-between"
          alignItems={{ base: "flex-start", lg: "flex-end" }}
          flexDir={{ base: "column", lg: "row" }}
          pb={{ base: 8, lg: 14 }}
        >
          <RichtextAdapter content={heading} customStyles={headingStyles} />
        </Flex>
        <SimpleGrid columns={{ base: 1, lg: 3 }} spacing={{ base: 12, lg: 8 }}>
          {(items || []).map((item: HowScoreIsCalculatedItems) => {
            const { heading, text, icon } = item;

            const Icon = icons[icon];

            return (
              <Flex key={heading} flexDir="column" justifyContent="flex-start">
                {Icon && <Icon h="auto" w={12} mb={6} color="primary.500" />}
                {heading && (
                  <Heading variant={headingSize} as={headingSize as As} mb={{ base: 2, lg: 4 }}>
                    {heading}
                  </Heading>
                )}
                <RichtextAdapter content={text} customStyles={itemTextStyles} />
              </Flex>
            );
          })}
        </SimpleGrid>
      </Box>
    </Grid>
  );
};

export default HowScoreIsCalculated;
